import { SortOrdering } from '@app/core/enums/sort-ordering';
import { Guid } from 'guid-typescript';

export class SideListModel {
  name: string;
  id: any;
  isSelected? = false;
  universalId?: Guid;
}

export class HighLightModel {
  sortBy: string = SortOrdering.createdOn;
  isHighlighted = false;
  moduleId?: number;
}
